import React from 'react';
import { BlogBanner } from 'libs/brand-system/src/components/BlogBanner';
import { ButtonTracking } from 'libs/growth-platform-brand-system-v2/src/utils/tracking/ButtonTracking';
import { ButtonV2 } from 'libs/growth-platform-brand-system-v2/src/components/ButtonV2';
import { useScreenSize } from 'libs/growth-platform-brand-system-v2/src/utils/utils';
import { morphism } from 'morphism';
import { schemaDatoButton } from '../../morphismSchema/schemaDatoButton';

export const BlogBannerComponent = ({ block, index, ctaData }: any) => {
  const screenSize = useScreenSize();

  const ctaProps = morphism(schemaDatoButton, {
    ...block?.banner?.banner?.[0]?.cta[0],
    ...ctaData,
    screenSize,
  });

  return (
    <BlogBanner
      title={block?.banner?.banner?.[0]?.title}
      image={block?.banner?.banner?.[0]?.image}
      cta={
        <ButtonTracking
          component={ButtonV2}
          labelTracking={ctaProps?.title}
          section={`${index}_DatoCmsBlogBannerBlock`}
          {...ctaProps}
        />
      }
    />
  );
};

export default BlogBannerComponent;
